import ms01 from "./ms01" ;
import ms02 from "./ms02";
import ms03 from "./ms03";
import ms04 from "./ms04";
import ms05 from "./ms05";
import ms06 from "./ms06";
import ms07 from "./ms07";
import ms08 from "./ms08";
import ms09 from "./ms09";
import ms10 from "./ms10";
import ms11 from "./ms11";
import ms12 from "./ms12";
import ms87 from "./ms87";
import ms85 from "./ms85";
import ms83 from "./ms83";
import ms84 from "./ms84";
import ms86 from "./ms86";
import ms42 from "./ms42";
import ms15 from "./ms15";
import ms16 from "./ms16";
import ms17 from "./ms17";
import ms18 from "./ms18";
import ms19 from "./ms19";
import ms20 from "./ms20";
import ms21 from "./ms21";
import ms171 from "./ms171";
import ms22 from "./ms22";
import ms23 from "./ms23";
import ms25 from "./ms25";
import ms26 from "./ms26";
import ms27 from "./ms27";
import ms28 from "./ms28" ;
import ms30 from "./ms30";
import ms31 from "./ms31";
import ms35 from "./ms35";
import ms38 from "./ms38";
import ms36 from "./ms36";
import ms180 from "./ms180";

export default {
    ms01,
    ms02,
    ms03,
    ms04,
    ms05,
    ms06,
    ms07,
    ms08,
    ms09,
    ms10,
    ms11,
    ms12,
    ms87,
    ms85,
    ms83,
    ms84,
    ms86,
    ms42,
    ms15,
    ms16,
    ms17,
    ms18,
    ms19,
    ms20,
    ms21,
    ms171,
    ms22,
    ms23,
    ms25,
    ms26,
    ms27,
    ms28,
    ms30,
    ms31,
    ms35,
    ms38,
    ms36,
    ms180

}